import React from "react";
import * as PropTypes from "prop-types";
import {
    CAlert,
    CBadge,
    CBreadcrumb,
    CBreadcrumbItem,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCollapse,
    CDataTable,
    CLink,
    CListGroup,
    CListGroupItem,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CNav,
    CNavItem,
    CNavLink,
    CPopover,
    CTabContent,
    CTabPane,
    CTabs,
    CToast,
    CToastBody,
    CToaster,
    CToastHeader,
    CTooltip,
} from "@coreui/react";

const defaultRequiredProps = {
// id: PropTypes.string.isRequired,
// name: PropTypes.string.isRequired,
// label: PropTypes.string.isRequired,
// value: PropTypes.string.isRequired,
// placeholder: PropTypes.string.isRequired,
// className: PropTypes.func.isRequired,
// onChange: PropTypes.func.isRequired
}

export const Link = (props) => {

    const handleClick = (e) => {
        //Todo handle default task
        props.onClick && props.onClick(e)
    }

    return (
        <CLink
            onClick={handleClick}
        >
            {props.children}
        </CLink>
    )

}

Link.propTypes = Object.assign({}, defaultRequiredProps)

export const Card = (props) => {

    return (
        <CCard>
            {props.header && <CCardHeader>{props.header}</CCardHeader>}
            <CCardBody>{props.children}</CCardBody>
            {props.footer && <CCardFooter>{props.footer}</CCardFooter>}
        </CCard>
    )

}

Card.propTypes = Object.assign({}, defaultRequiredProps, {
    // header: PropTypes.string,
    // children: PropTypes.any.isRequired,
    // footer: PropTypes.string
})

export const Collapse = (props) => {

    return (
        <CCollapse show={props.collapse}>
            {props.children}
        </CCollapse>
    )

}

Collapse.propTypes = Object.assign({}, defaultRequiredProps, {
    // collapse: PropTypes.bool.isRequired,
})

export const ListGroup = (props) => {

    const handleClick = (e) => {
        //Todo handle default task
        props.onClick && props.onClick(e, parseInt(e.target.id))
    }

    return (
        <CListGroup>
            {props.items.map((item, i) => {
                return <CListGroupItem key={i} id={i} onClick={handleClick}
                                       active={props.active === i}>{item}</CListGroupItem>
            })}
        </CListGroup>
    )

}

ListGroup.propTypes = Object.assign({}, defaultRequiredProps, {
    active: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
})

export const TabContent = (props) => {

    const handleClick = (e) => {
        //Todo handle default task
        props.onClick && props.onClick(e)
    }

    return (
        <CTabContent>
            {props.items.map((item, i) => {
                return <CTabPane active={i === props.active} key={i} onClick={handleClick}>{item}</CTabPane>
            })}
        </CTabContent>
    )

}

TabContent.propTypes = Object.assign({}, defaultRequiredProps, {
    active: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
})

export const Popover = (props) => {

    const handleClick = (e) => {
        //Todo handle default task
        e.preventDefault()
        props.onClick && props.onClick(e)
    }

    return (
        <CPopover
            header={props.header}
            content={props.content}
            placement={props.placement || 'top'}
            interactive={props.interactive || true}
            trigger={props.trigger}
        ><CLink
            onClick={handleClick}>{props.text}</CLink></CPopover>
    )

}

Popover.propTypes = Object.assign({}, defaultRequiredProps, {
    text: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    header: PropTypes.string,
    placement: PropTypes.string,
    trigger: PropTypes.string,
    interactive: PropTypes.bool,
    onClick: PropTypes.func
})

export const Table = (props) => {

    return (
        <CDataTable
            items={props.data}
            fields={props.columns}
            striped={props.striped}
            bordered={props.bordered}
            dark={props.dark}
            hover={props.hover}
            size={props.size}
            pagination={props.pagination}
            scopedSlots={props.scopedSlots}
            loading={props.loading}
            clickableRows={props.clickableRows}
            onRowClick={props.onRowClick}
            columnFilter={props.columnFilter}
            sorter={props.sorter}
            onSorterValueChange={props.onSorterValueChange}
            addTableClasses={props.addTableClasses}
            // sortingIconSlot={(a, b, c, d, e, f) => console.log(a, b, c, d, e, f)}
        />
    )

}

Table.propTypes = Object.assign({}, defaultRequiredProps, {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    scopedSlots: PropTypes.object,
    striped: PropTypes.bool,
    bordered: PropTypes.bool,
    dark: PropTypes.bool,
    hover: PropTypes.bool,
    pagination: PropTypes.bool,
    size: PropTypes.string,
    loading: PropTypes.bool
})


export const Tabs = (props) => {

    const navItem = props.items.map((item, i) => {
        return (
            <CNavItem key={i}>
                <CNavLink data-tab={i}>
                    {item.title}
                </CNavLink>
            </CNavItem>
        )
    });
    const tabPane = props.items.map((item, i) => {
        return (
            <CTabPane key={i} data-tab={i}>
                {item.content}
            </CTabPane>
        )
    });

    const handleActiveTabChange = (idx) => {
        console.log(idx)
        props.onActiveTabChange && props.onActiveTabChange(idx);
    }

    return (
        <CTabs activeTab={props.activeTab.toString()} onActiveTabChange={handleActiveTabChange}>
            <CNav variant={props.variant || "tabs"}>
                {navItem}
            </CNav>
            <CTabContent>
                {tabPane}
            </CTabContent>
        </CTabs>
    )

}

Tabs.propTypes = Object.assign({}, defaultRequiredProps, {
    items: PropTypes.array.isRequired,
    activeTab: PropTypes.any.isRequired,
    variant: PropTypes.string,
    onActiveTabChange: PropTypes.func,
})

export const Tooltip = (props) => {

    return (
        <CTooltip
            content={props.content}
            placement={props.placement}
            children={props.children}
        >
            {props.children}
        </CTooltip>
    )

}

Tooltip.propTypes = {
    content: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired,
}

Tabs.propTypes = Object.assign({}, defaultRequiredProps, {
    items: PropTypes.array.isRequired,
    activeTab: PropTypes.any.isRequired,
    variant: PropTypes.string,
    onActiveTabChange: PropTypes.func,
})

export const Breadcrumb = (props) => {

    const breadcrumbItem = props.items.map((item, i) => {
        return (
            <CBreadcrumbItem key={i} active={i === props.items.length - 1}>
                {i === props.items.length - 1 ? item.label : <CLink href={item.href}>{item.label}</CLink>}
            </CBreadcrumbItem>
        )
    })

    return (
        <CBreadcrumb>
            {breadcrumbItem}
        </CBreadcrumb>
    )

}

Breadcrumb.propTypes = {
    items: PropTypes.array.isRequired,
}

export const Alert = (props) => {

    return (
        (props.children && props.children !== 'null' && props.children !== 'undefined') ?
            <CAlert color={props.color || "primary"}>
                {typeof props.children === 'string' ? props.children : JSON.stringify(props.children)}
            </CAlert> : <></>
    )

}

Alert.propTypes = {
    children: PropTypes.any.isRequired,
    color: PropTypes.string
}

export const Badge = (props) => {

    return (
        <CBadge
            color={props.color || "primary"}
            className={props.className || "mr-1"}
            shape={props.shape}
            href={props.href}
        >
            {props.children}
        </CBadge>
    )

}

Badge.propTypes = {
    children: PropTypes.any.isRequired,
    color: PropTypes.string,
    shape: PropTypes.string,
    href: PropTypes.string,
    className: PropTypes.string
}

export const Modal = (props) => {

    const handleClose = () => {
        props.onClose()
    }

    return (
        <CModal
            show={props.show}
            onClose={handleClose}
            size={props.size}
            color={props.color}
        >
            {props.title && <CModalHeader closeButton><CModalTitle>{props.title}</CModalTitle></CModalHeader>}
            <CModalBody>
                {props.body}
            </CModalBody>
            {props.footer && <CModalFooter>{props.footer}</CModalFooter>}
        </CModal>
    )

}

Modal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    body: PropTypes.any.isRequired,
    title: PropTypes.any,
    footer: PropTypes.any,
    size: PropTypes.string,
    color: PropTypes.string,
}

/**
 *  position: static, top-left, top-center, top-right, top-full, bottom-left, bottom-center, bottom-right, bottom-full
 *
 */

export const Toaster = (props) => {

    return (
        <CToaster
            position={props.position}
        >
            {props.children}
        </CToaster>

    )

}

Toaster.propTypes = {
    position: PropTypes.string.isRequired,
    children: PropTypes.array.isRequired,
}

export const Toast = (props) => {
    // console.log(props)
    return (
        <CToast
            key={`id-${new Date().getTime()}`}
            show={props.show || true}
            autohide={props.autoHide || 10000}
            fade={props.fade}
            className={props.className || ""}
        >
            <CToastHeader closeButton={props.closeButton}>
                {props.title}
            </CToastHeader>
            <CToastBody>
                {props.children}
            </CToastBody>
        </CToast>

    )

}

Toast.propTypes = {
    title: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    show: PropTypes.bool,
    autohide: PropTypes.number,
    fade: PropTypes.bool,
    closeButton: PropTypes.bool,
}
